/**
 * AssistantMessage — Claude-Bubble links mit Markdown + inline Tool-Calls (#1180).
 *
 * Rendert content_blocks (text + tool_use + tool_result) chronologisch.
 * Während Streaming: text wird in `streamingText` gepusht, tool_calls in `liveToolCalls`.
 */
import { Bot } from 'lucide-react';
import ChatMarkdown from './ChatMarkdown';
import ToolCallExpand from './ToolCallExpand';

/**
 * blocks: Array of { type: 'text', text } | { type: 'tool_use', id, name, input } | { type: 'tool_result', tool_use_id, content, is_error, durationMs }
 * Aus DB: assistant.content_blocks ist nur text + tool_use. tool_result-Blocks
 * kommen aus der nächsten 'tool'-Message (role='tool'). Für Anzeige flatten wir
 * tool_use + ihren entsprechenden tool_result aus toolResults zusammen.
 *
 * Für Live-Streaming bauen wir blocks aus liveBlocks (text_delta akkumuliert + tool_use + tool_result).
 */
export default function AssistantMessage({
  blocks,
  toolResults,
  streaming,
  thinking,
}) {
  // toolResults: Map<tool_use_id, { name, output, durationMs, isError }>
  const tr = toolResults || {};

  return (
    <div className="flex justify-start mb-4">
      <div className="flex gap-2.5 max-w-[88%] w-full">
        <div className="w-8 h-8 flex-shrink-0 rounded-full bg-[#338edc]/10 flex items-center justify-center">
          <Bot size={16} className="text-[#338edc]" />
        </div>
        <div className="flex-1 min-w-0 pt-1">
          {(blocks || []).map((b, i) => {
            if (b.type === 'text') {
              return (
                <div key={i} className="text-[14px] leading-relaxed text-[var(--text-primary)]">
                  <ChatMarkdown>{b.text || ''}</ChatMarkdown>
                </div>
              );
            }
            if (b.type === 'tool_use') {
              const result = tr[b.id];
              return (
                <ToolCallExpand
                  key={b.id || i}
                  call={{
                    name: b.name,
                    input: b.input,
                    output: result?.output,
                    durationMs: result?.durationMs,
                    isError: result?.isError,
                  }}
                />
              );
            }
            return null;
          })}
          {thinking && streaming && (
            <div className="flex items-center gap-1 mt-1 text-[var(--text-tertiary)] text-xs">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#338edc] animate-pulse" />
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#338edc] animate-pulse" style={{ animationDelay: '0.15s' }} />
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#338edc] animate-pulse" style={{ animationDelay: '0.3s' }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
